import React from 'react';
import './Footer.css';
import { FaInstagram, FaLinkedin } from 'react-icons/fa';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-brand">
          <span className="footer-logo-text">Sermyble</span>
          <p>The food court management platform that helps you grow.</p>
        </div>
        <div className="footer-col">
          <h5>Contact</h5>
          <p>Gachibowli, Hyderabad 500032</p>
          <p><a href="mailto:info@aslinformationservices.com">info@aslinformationservices.com</a></p>
          <p>+91 70932 81075</p>
        </div>
        <div className="footer-col">
          <h5>Follow Us</h5>
          <div className="footer-socials">
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn"><FaLinkedin /></a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Sermyble. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
